import { useField } from 'formik'
import { FC } from 'react'
import Select from 'react-select'

import { SelectInputField } from '../../../models/reusable-components'
import ListItems from '../../UI/Inputs/MultiselectInput/ListItem'
import Indicator from '../../UI/Inputs/MultiselectInput/Indicator'
import MultiValue from './MultiValue'

import './../../UI/Inputs/MultiselectInput/MultiselectInput.scss'

const MultiselectInput: FC<SelectInputField> = ({ name, options, placeholder }) => {
  const [{ value }, meta, helper] = useField({
    name,
    multiple: true,
    type: 'select'
  })

  const onChange = (event: any, rest: any) => {
    const newValue = event ? event : []
    helper.setValue(newValue)
  }

  const settings = {
    name,
    options,
    placeholder,
    onChange,
    closeMenuOnSelect: false,
    onBlur: () => {
      helper.setTouched(true, true)
    },
    classNamePrefix: 'multiselect-input',
    isDisabled: !options.length
  }

  return (
    <div className={`multiselect-input ${meta.touched && meta.error && 'error'}`}>
      <Select
        defaultValue={[]}
        components={{
          IndicatorSeparator: () => null,
          IndicatorsContainer: Indicator,
          MenuList: (props) => <ListItems {...{ onChange, value, ...props }} />,
          MultiValue: MultiValue
        }}
        {...settings}
        // @ts-ignore
        isMulti={true}
      />
      {meta.touched && meta.error && (
        <div className='validation-error'>
          <div className='validation-error__icon'></div>
          {meta.error}
        </div>
      )}
    </div>
  )
}

export default MultiselectInput
